<template>
  <div id="app">
    <T1HeadScripts />
    <a-layout id="components-layout-demo-top" class="layout">
      <T1Header />
      <T1HotelContent />
      <T1Footer />
    </a-layout>
  </div>
</template>

<script>
import T1HeadScripts from "./components/T1HeadScripts";
import T1Header from "./components/T1Header/T1Header";
import T1HotelContent from "./components/T1HotelContent";
import T1Footer from "./components/T1Footer/T1Footer";


export default {
  name: "app",
  components: {
    T1HeadScripts,
    T1Header,
    T1HotelContent,
    T1Footer
  }
};
</script>
